const initialState = {
    listOfTags: [],
    isGettingListOfTags: false,
    isAddingTag: false
}

export default initialState;
